module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/iot-2015-05-28.paginators.json
// module id = 380
// module chunks = 1